var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#668A90",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M594 16c.513 0 .936.322.993.736l.007.097V18h1.45c1.352 0 2.458.99 2.545 2.242l.005.158v11.2c0 1.325-1.142 2.4-2.55 2.4h-11.9c-1.408 0-2.55-1.075-2.55-2.4V20.4c0-1.325 1.142-2.4 2.55-2.4H586v-1.167c0-.46.448-.833 1-.833.513 0 .936.322.993.736l.007.097V18h5v-1.167c0-.46.448-.833 1-.833zm3.3 8h-13.6v7.6c0 .408.324.744.743.794l.107.006h11.9c.47 0 .85-.358.85-.8V24zM586 19.599l-1.45.001c-.47 0-.85.358-.85.8V22h13.6v-1.6c0-.408-.324-.744-.743-.794l-.107-.006-1.45-.001v.568c0 .46-.448.833-1 .833-.513 0-.936-.322-.993-.736l-.007-.097v-.568h-5v.568c0 .46-.448.833-1 .833-.513 0-.936-.322-.993-.736l-.007-.097v-.568z",
    transform: "translate(-1083 -457) translate(471 326) translate(30 115)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3430d8d9a8b5815b30747aa784b05d37.svg";
export { ForwardRef as ReactComponent };